<template>
  <div class="footer" :class="isGray ? 'wrapperImg' : ''">
    <div class="footer_bottom container-width">
      <div>
        <p>南湖院区：中国辽宁省沈阳市和平区三好街36号&nbsp; 邮编：110004</p>
        <p>滑翔院区：中国辽宁省沈阳市铁西区滑翔路39号&nbsp; 邮编：110022</p>
        <p>沈北院区：中国辽宁省沈阳市沈北新区蒲河大道16号&nbsp; 邮编：110134</p>
        <p>
          科技创新中心：中国辽宁省本溪经济开发区木兰路7号&nbsp; 邮编：117004
        </p>
      </div>
      <div>
        <p>统一呼叫平台：(024)96615</p>
        <p>版权所有：中国医科大学附属盛京医院</p>
        <p>
          <a href="https://beian.miit.gov.cn/#/Integrated/index"
            >辽ICP备09005395号</a
          >
        </p>
        <p>您是第{{ visitorNumber }} 位访客，感谢您的关注！</p>
      </div>
    </div>
  </div>
</template>

<script>
import service from "../service/index";
export default {
  name: "FOOTER",
  props: {},
  data() {
    return {
      visitorNumber: 0,
      isGray: true, // 首页是否置灰
    };
  },
  methods: {
    getGraySetting() {
      service.setIndexGray({}, (res) => {
        this.isGray = res;
      });
    },
  },
  mounted() {
    this.getGraySetting();
  },
  created() {
    this.visitorNumber = localStorage.getItem("visitorNum");
  },
};
</script>

<style scoped lang="scss">
.isGray {
  -webkit-filter: grayscale(100%);
  filter: Gray;
}
.footer {
  background: #00479d;
  color: #fff;
  margin: 0 auto;
}
.footer_bottom {
  padding: 50px 0 50px 0;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -moz-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  box-sizing: border-box;
  p {
    font-size: 1rem;
    line-height: 40px;
  }
  a {
    font-size: 1rem;
    line-height: 40px;
    color: #fff;
  }
}

/* 小屏幕（平板，大于等于 768px） */
@media only screen and (max-width: 768px) {
  .footer_bottom {
    padding: 30px 10px 30px 10px;
    p {
      font-size: 12px;
      line-height: 24px;
    }
    a {
      font-size: 12px;
      line-height: 24px;
    }
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media only screen and (min-width: 992px) {
  .footer_bottom {
    -moz-flex-direction: row;
    -webkit-flex-direction: row;
    flex-direction: row;
  }
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media only screen and (min-width: 1200px) {
}

/* 小屏幕（大桌面显示器 大于等于 1330px） */
@media only screen and (min-width: 1330px) {
}

/* 小屏幕（大桌面显示器 大于等于 1900px） */
@media only screen and (min-width: 1900px) {
}
</style>
